export default function LoadingScreen() {
  return (
    <div className="flex items-center justify-center h-[100dvh] w-full bg-dunea-elements-background-depth-1">
      <div className="flex flex-col items-center gap-4">
        <div className="i-svg-spinners:90-ring-with-bg text-4xl text-dunea-elements-textPrimary" />
        <p className="text-dunea-elements-textSecondary text-sm">Loading…</p>
      </div>
    </div>
  );
}
